// extracted by mini-css-extract-plugin
export default {"TopMenuDesktop":"TopMenuDesktop_TopMenuDesktop__CXCqh","item":"TopMenuDesktop_item__s80Ua","placeholder":"TopMenuDesktop_placeholder__Ms5zG"};